import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MenuService } from '../menu.service';
import {
  ConnectionPositionPair,
  CdkConnectedOverlay,
  Overlay,
  CdkOverlayOrigin,
} from '@angular/cdk/overlay';
import { MenuItemLocal } from '../menu-item.model';
import { first } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SubMenuComponent } from '../sub-menu/sub-menu.component';
import { ClickOutsideDirective } from '../../../shared/click-outside.directive';
import { RouterLink } from '@angular/router';
import { SvgComponent } from '@inspark/inspark-components';
import { ICONS_MAP } from '../../../shared/constnts/icons-map';

@Component({
  selector: 'app-menu-container',
  standalone: true,
  templateUrl: './menu-container.component.html',
  imports: [
    NgIf,
    TranslateModule,
    CdkOverlayOrigin,
    SubMenuComponent,
    CdkConnectedOverlay,
    ClickOutsideDirective,
    RouterLink,
    NgClass,
    AsyncPipe,
    SvgComponent,
  ],
  styleUrls: ['./menu-container.component.scss'],
})
export class MenuContainerComponent implements OnInit {
  @Input() menu: MenuItemLocal;
  @Input() isMenuCollapsed: boolean;
  @Input() isDesktop: boolean;
  @Input() isConfigMode: boolean;

  @Output() favoriteMenuSelected = new EventEmitter();

  // @ts-ignore
  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay: CdkConnectedOverlay;

  public connectionPositionPairs: ConnectionPositionPair[] = [
    new ConnectionPositionPair(
      { originX: 'end', originY: 'top' },
      {
        overlayX: 'start',
        overlayY: 'top',
      },
      0,
      3,
      'cdk-overlay-pane_top'
    ),
    new ConnectionPositionPair(
      { originX: 'end', originY: 'center' },
      {
        overlayX: 'start',
        overlayY: 'center',
      },
      0,
      0,
      'cdk-overlay-pane_center'
    ),
    new ConnectionPositionPair(
      { originX: 'end', originY: 'bottom' },
      {
        overlayX: 'start',
        overlayY: 'bottom',
      },
      0,
      0,
      'cdk-overlay-pane_bottom'
    ),
  ];

  protected readonly ICONS_MAP = ICONS_MAP;

  constructor(
    private element: ElementRef,
    private menuService: MenuService,
    private overlay: Overlay,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    return;
  }

  /*
    public isActiveChild(subMenuArray: MenuItem[]) {
      return subMenuArray
        .some(menuItem => window.location.hash.startsWith(this.urlPrefix + '/' + menuItem.pathArray.join('/')));
    }
  */

  public toggleMenuState(menu: MenuItemLocal) {
    menu.state = !menu.state;
    if (menu.pathArray) {
      const location = this.menuService.isActiveLink(menu.pathArray.join('/'));
    }

    // Every time submenu open check top of overlay is not outside viewport. If so set it to 0.
    this.cdkConnectedOverlay?.positionChange.pipe(first()).subscribe((posChange) => {
      // change any properties that you need about the connectedOverlay
      this.cdkConnectedOverlay.offsetY = 0;
      // this will trigger again positionChange thats why we only take the first
      this.cdkConnectedOverlay.overlayRef.updatePosition();

      if (this.cdkConnectedOverlay.overlayRef.overlayElement.offsetTop < 0) {
        this.cdkConnectedOverlay.overlayRef.overlayElement.style.top = '0';
      }
    });
  }

  public clickedOutsideOverlay(event, menu) {
    if (!this.element.nativeElement.contains(event.target)) {
      menu.state = false;
    }
  }

  protected isMdIcon(icon: string) {
    if (!icon) {
      return false;
    }
    return icon.startsWith('md');
  }

  protected getMdIcon(icon: string) {
    if (!icon) {
      return 'cloud';
    }
    return icon.substr(2);
  }

  protected isFaIcon(icon: string) {
    if (!icon) {
      return false;
    }
    return icon.startsWith('fa');
  }

  protected isSvgIcon(icon: string) {
    if (!icon) {
      return false;
    }
    return icon.startsWith('svg');
  }

  private getSvgIcon2(icon: string) {
    if (icon.startsWith('svg')) {
      const name = icon.substr(4);
      return name.trim().toLowerCase();
    }
    return '';
  }
}
